import React, { useState } from "react";
import Account from "./Account";
import Blocked from "./Blocked";
import Notifications from "./Notfications";
import "./Settings.css";
import SideMenu from "../../components/SideMenu";

export default function Settings() {
  const [currentView, setCurrentView] = useState("Account");
  const renderComponent = () => {
    switch (currentView) {
      case "Account":
        return <Account />;
      case "Blocking":
        return <Blocked />;
      case "Notifications":
        return <Notifications />;
      default:
        return null;
    }
  };
  return (
    <div className="mb-5 container">
      <div className="row">
        <div className="col-3 side-menu-container mx-3">
          <SideMenu />
        </div>
        <div className="col bg-white sideBarMargin my-2">
          <div className="blueBanner">
            <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
              Account Settings
            </p>
          </div>
          <div className="d-flex justify-content-end">
          <button  onClick={() => setCurrentView("Account")} className="settings-menu-button">Account</button>   <button    onClick={() => setCurrentView("Notifications")} className="settings-menu-button">Notifications</button>   <button  onClick={() => setCurrentView("Blocking")} className="settings-menu-button">Blocking</button>
          </div>

          <div>{renderComponent()}</div>
          
        </div>
      </div>

 
    </div>
  );
}
